/*
 * NANOAGRO — Caso de estudio: animación de la sección caso-estudio.liquid
 *
 * - Aparición al hacer scroll (fade + subida) de cada bloque, escalonada en
 *   las rejillas de tarjetas.
 * - Contadores en las cifras (de 0 al valor, con signo, decimales y %/pp).
 * - En la barra de pestañas, deja visible la pestaña activa en móvil.
 *
 * Reglas: sin librerías; nada se oculta si este archivo no carga (la clase
 * .cde-js que oculta la pone este script); con "reducir movimiento" no se
 * anima nada; lo que ya está a la vista al cargar no se oculta (sin parpadeo);
 * funciona con varias secciones en la página y en el editor de temas.
 */
(function () {
  'use strict';
  if (window.__cdeAnim) return; /* el editor puede cargar el archivo dos veces */
  window.__cdeAnim = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* Qué se anima. Los grupos (tarjetas en rejilla) llevan escalonado. */
  var SOLOS = '.cde-cifras h2, .cde-tabla h2, .cde-texto h2, .cde-enlaces h2, .cde-sub, ' +
    '.cde-etapa, .cde-tabla__wrap, .cde-rich, .cde-cta .cde__wrap, .cde-nota p';
  var GRUPOS = '.cde-cifra, .cde-link, .cde-eje';
  var PASO = 90; /* ms entre tarjetas */
  var TOPE = 5;  /* después de 5 tarjetas ya no se espera más */

  /* ── Contadores ─────────────────────────────────────────── */
  /* Solo si el texto es UN número con adornos sin dígitos: "+52.1%", "−10 días",
     "~60%", "+25.0 pp". "3 → 1" o "Compatible" se dejan tal cual. */
  var RE_NUM = /^([^\d+\-−]*)([+\-−]?)(\d+(?:[.,]\d+)?)([^\d]*)$/;

  function prepararContador(el) {
    if (el.children.length) return null;
    var txt = el.textContent.trim();
    var m = RE_NUM.exec(txt);
    if (!m) return null;
    var num = parseFloat(m[3].replace(',', '.'));
    if (!(num >= 2) && m[3].indexOf('.') < 0 && m[3].indexOf(',') < 0) return null; /* "1 ciclo": no vale la pena */
    var sep = m[3].indexOf(',') >= 0 ? ',' : '.';
    var dec = (m[3].split(sep)[1] || '').length;
    return { el: el, final: txt, pre: m[1] + m[2], post: m[4], num: num, dec: dec, sep: sep };
  }

  function contar(c) {
    if (!c || c.hecho) return;
    c.hecho = true;
    var dur = 1100, t0 = null;
    function fmt(v) { return c.pre + v.toFixed(c.dec).replace('.', c.sep) + c.post; }
    function paso(t) {
      if (!c.el.isConnected) return;
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3); /* ease-out */
      if (p < 1) { c.el.textContent = fmt(c.num * e); requestAnimationFrame(paso); }
      else { c.el.textContent = c.final; c.el.style.minWidth = ''; } /* texto final = el original, exacto */
    }
    c.el.style.minWidth = c.el.getBoundingClientRect().width + 'px'; /* sin saltos de ancho */
    c.el.textContent = fmt(0);
    requestAnimationFrame(paso);
  }

  /* ── Pestaña activa visible en móvil ────────────────────── */
  function centrarPestana(root) {
    var lists = root.querySelectorAll('.cde-tabs__list');
    for (var i = 0; i < lists.length; i++) {
      var a = lists[i].querySelector('.is-active');
      if (a && lists[i].scrollWidth > lists[i].clientWidth) {
        lists[i].scrollLeft = a.offsetLeft - (lists[i].clientWidth - a.offsetWidth) / 2;
      }
    }
  }

  function revelar(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    if (el._cdeContador) contar(el._cdeContador);
    var d = parseInt(el.style.getPropertyValue('--cde-d'), 10) || 0;
    /* Al terminar se quita la clase: vuelve el comportamiento normal (hover, etc.) */
    setTimeout(function () {
      el.classList.remove('cde-rv', 'is-in');
      el.style.removeProperty('--cde-d');
    }, d + 750);
  }

  function init(root) {
    if (!root || root.getAttribute('data-cde-init')) return;
    root.setAttribute('data-cde-init', '1');
    centrarPestana(root);
    if (reduce || !hasIO) return; /* todo queda visible y quieto */

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var objetivos = [];
    var vistos = new Set();

    function agregar(el, delay) {
      if (vistos.has(el) || el.closest('.cde-hero')) return;
      vistos.add(el);
      var r = el.getBoundingClientRect();
      var aLaVista = r.top < vh && r.bottom > 0;
      var num = el.matches('.cde-cifra') ? el.querySelector('b') :
                el.matches('.cde-etapa') ? el.querySelector('.cde-etapa__k b') : null;
      var c = num ? prepararContador(num) : null;
      if (aLaVista) { if (c) contar(c); return; } /* ya visible: no se oculta */
      el._cdeContador = c;
      if (delay) el.style.setProperty('--cde-d', delay + 'ms');
      el.classList.add('cde-rv');
      objetivos.push(el);
    }

    var solos = root.querySelectorAll(SOLOS);
    for (var i = 0; i < solos.length; i++) agregar(solos[i], 0);
    var grupos = root.querySelectorAll(GRUPOS);
    for (var j = 0; j < grupos.length; j++) {
      var g = grupos[j], idx = 0, h = g.previousElementSibling;
      while (h) { idx++; h = h.previousElementSibling; }
      agregar(g, Math.min(idx, TOPE) * PASO);
    }
    if (!objetivos.length) return;

    root.classList.add('cde-js');
    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) { revelar(entries[k].target); io.unobserve(entries[k].target); }
      }
    }, { rootMargin: '0px', threshold: 0.1 });
    for (var n = 0; n < objetivos.length; n++) io.observe(objetivos[n]);
    root._cdeIO = io;
  }

  function initTodo(scope) {
    var roots = (scope || document).querySelectorAll('[data-cde]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  /* Editor de temas: la sección se vuelve a pintar → se inicializa de nuevo */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-cde]');
    if (r && r._cdeIO) r._cdeIO.disconnect();
  });
  /* Al elegir un bloque en el editor se muestra al instante */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target, els = [t].concat([].slice.call(t.querySelectorAll('.cde-rv')));
    for (var i = 0; i < els.length; i++) if (els[i].classList.contains('cde-rv')) revelar(els[i]);
  });
})();
